import React from 'react';
import { withCubicleFallback } from '../../../utils/CubicleFallback';

const Dialog = (props) => {
  return <>Dialog</>;
};

const Default = withCubicleFallback(Dialog);
export { Default as Dialog };
